import React from 'react';
// import styles from './ValuationOptions.scss';
import styles from './ValuationWidget.scss';
import HouseSvg from './HouseSvg';
import ApartmentSvg from './ApartmentSvg';
import { i18n, IValuationData, ISubcode } from './ValuationWidget';

export interface IValuationOptionsProps {
    data: IValuationData;
    nextStep: (name: string, value: string) => void;
    step: any; // TODO!!!!!
}

const ValuationOptions: React.FC<React.PropsWithChildren<IValuationOptionsProps>> = ({ step, data, nextStep = () => {} }) => {
    const name = step.name;

    return (
        <div className={styles.options + ' ' + styles[name] + ' ' + styles.more}>
            {Object.keys(step?.options[data.code]).map((key) => {
                const option = step.options[data.code][key];
                return (
                    <div
                        key={key}
                        className={styles.option + (key === data[name] ? ' ' + styles.active : '')}
                        onClick={() => {
                            nextStep(name, key);
                        }}
                    >
                        {name === 'subcode' &&
                            (data.code === 'house' ? <HouseSvg variant={key as ISubcode} align="left" /> : <ApartmentSvg variant={key as ISubcode} />)}
                        <span>{option}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default ValuationOptions;
